<div class="home-page__content">
  <div class="home-page_content-container">
    <div class="product-container__content">
      <h2 class="product-container__title">Products</h2>
      <lib-home-product-list></lib-home-product-list>
    </div>
    <div class="resource-container__content">
      <h2 class="resource-container__title">Resources</h2>
      <lib-home-resource-list> </lib-home-resource-list>
    </div>
  </div>
  <fa-icon
    class="home__plant-icon"
    svgIcon="/assets/images/home_plant_icon.svg"
  ></fa-icon>
</div>
